
import React from 'react';

import { withAssetSelector } from '../../../../../Uploader';
import './_comment-title.scss';








function CommentTitle({
  color,
  brightness,
  commentIndex,
  asset
}) {
  const { title } = asset || {};

  return (
    <div className="comment-title">
      <div
        className="comment-title__number"
        style={{ backgroundColor: color, filter: brightness }}>

        {commentIndex + 1}
      </div>
      <div className="comment-title__title">
        {title || 'UNKNOWN'}
      </div>
    </div>);

}

export default withAssetSelector(CommentTitle);